import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./use-auth";
import { AuditAction } from "@/types/audit";

interface LogActionParams {
  action: AuditAction | string;
  entity_type: string;
  entity_id?: string;
  target_user_id?: string;
  company_id?: string;
  old_values?: any;
  new_values?: any;
  meta?: Record<string, any>;
}

export function useAuditLogger() {
  const { user } = useAuth();

  const logAction = async (params: LogActionParams) => {
    try {
      const { error } = await supabase.from('audit_logs').insert({
        actor_user_id: user?.id || null,
        company_id: params.company_id || null,
        action: params.action,
        entity_type: params.entity_type,
        entity_id: params.entity_id || null,
        target_user_id: params.target_user_id || null,
        old_values: params.old_values || null,
        new_values: params.new_values || null,
        meta: params.meta || {},
      });

      if (error) {
        console.error('❌ Failed to log audit action:', error);
      } else {
        console.log('✅ Audit logged:', params.action, params.entity_type);
      }
    } catch (error) {
      console.error('❌ Audit logging error:', error);
    }
  };

  return { logAction };
}
